import React, { useEffect } from 'react'
import { Dimensions, View } from 'react-native'
import { useTutorNoShow } from '../TutorNoShowContext'
import { DialogM } from '@common/components/alert/dialog/Dialog'
import { theme } from '@common/theme/theme'
import TextM from '@common/components/text/TextM'
import moment from 'moment'
import { findClosestNextOccurrence } from '../../../../../student/account/onboarding/LiveRoomCard'
import { liveService } from '@data/services/liveService'
import { PlaySoundM } from '@common/components/playSound/PlaySoundM'

/**
 * Modal confirming credit fallback when no compatible session found
 */
export function CreditModal() {
    const context = useTutorNoShow()

    // Guard: return null if provider is not present (e.g., trial sessions)
    if (!context) return null

    const {
        isCrediting,
        declinedByUser,
        liveSession,
        apiRequest,
        actions,
        skipCleanupRef,
        claimRejection,
    } = context

    useEffect(() => {
        if (!isCrediting) return

        // Play alert sound to notify student
        PlaySoundM.play(require('../../../../../../assets/sounds/question_002.mp3'))

        const closestNext = findClosestNextOccurrence([liveSession])
        const payload = {
            original_occurrence_date: closestNext?.date
                ? moment(closestNext.date).format('YYYY-MM-DD HH:mm')
                : undefined,
        }

        // Different messages based on whether user declined or no session was found
        const title = declinedByUser
            ? 'Tu préfères rattraper plus tard'
            : 'Ton tuteur est absent'

        const message = declinedByUser
            ? 'Pas de problème ! On te crédite une séance de rattrapage et on prévient tes parents.'
            : 'Malheureusement, aucune séance de rattrapage n\'est disponible aujourd\'hui. On te crédite un rattrapage et on prévient tes parents.'

        DialogM.show({
            champion: 'abou',
            variant: 'main',
            text1: title,
            component: (
                <View style={{ alignSelf: 'stretch', width: '100%', maxWidth: Dimensions.get('window').width - 60 }}>
                    <TextM wrap style={{ textAlign: 'center' }}>
                        {message}
                    </TextM>
                    {/* Info Box */}
                    <View
                        style={{
                            marginTop: 10,
                            padding: 15,
                            backgroundColor: theme.colors.greyBg,
                            borderRadius: 12,
                            borderLeftWidth: 4,
                            borderLeftColor: theme.colors.primary,
                        }}
                    >
                        <TextM
                            fontSize={14}
                            color={theme.colors.primary}
                            textAlign="center"
                            fontWeight="SemiBold"
                            wrap
                        >
                            💳 Séance de rattrapage créditée
                        </TextM>
                        <TextM
                            fontSize={13}
                            color={theme.colors.primary}
                            textAlign="center"
                            style={{ marginTop: 5 }}
                            wrap
                        >
                            Tu peux réserver une séance de rattrapage en cliquant sur le mail qui a été envoyé
                        </TextM>
                    </View>
                </View>
            ),
            buttonText1: 'Confirmer et quitter',
            buttonColor1: theme.colors.primary,
            onPress: () => {
                // Set flag BEFORE async call to prevent cleanup race condition
                if (skipCleanupRef) skipCleanupRef.current = true
                apiRequest(liveService.autoRecoveryFallback, { id: liveSession?.id }, payload)
            },
            preventAutoClose: true,
            exitButton: false,
        })

        return () => {
            if (isCrediting) {
                DialogM.hide()
            }
        }
    }, [isCrediting, declinedByUser])

    // Rendered here rather than from the provider so dialogs stay owned by
    // components. React runs this setup after the credit dialog's cleanup, so
    // the explanation replaces it instead of being closed by it.
    useEffect(() => {
        if (!claimRejection?.message) return

        DialogM.show({
            text1: 'Information',
            text2: claimRejection.message,
            exitButton: true,
            onPressBack: () => {},
        })
    }, [claimRejection])

    return null // Modal is controlled via DialogM.show
}
